import Rete from "rete";

export const FLOWSCHEMA_VERSION = "flowschema@0.1.0";
export var actionSocket = new Rete.Socket("Action");
export const DEFAULT_FLOW = "BASIC_FLOW";
